import React, {useEffect} from 'react';
import {Checkbox, Form, Input, Modal, Select, Switch} from "antd";

const { Option } = Select;
const { TextArea } = Input;

const formItemLayout = {
    wrapperCol: {offset: 5, span: 19},
};

const tailItemLayout = {
    labelCol: {span: 5},
    wrapperCol: {span: 19},
};

const formCheckboxLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16, offset: 4 },
};


const TraderStrategyDialog = ({  visible = false, data = {},
                        strategies = [],
                        assets = [],
                        dialogHandler = () => {}
                     }) => {
    const {id, isActive, strategy = {}, asset = {}} = data;
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            id, isActive, strategy, asset
        })
    }, [form, id, isActive, strategy, asset]);

    useEffect(() => {
        if (visible) {
            // Сбрасываем форму и устанавливаем новые значения
            form.resetFields();
            form.setFieldsValue({
                isActive,
                strategy,
                asset
            });
        }
    }, [visible, form, isActive, strategy, asset]);


    const onOk = () => {
        form.validateFields().then(values => {
            values = {
                ...data,
                ...values
            }
            dialogHandler(true, {...values})
        });
    }

    return (
        <Modal
            title= {id ? 'Редактирование настройки': 'Новая настройка'}
            className="uk-panel-title"
            open={visible}
            onCancel={() => dialogHandler(false)}
            onOk={onOk}
            width={600}
        >
            <Form form={form}
                  initialValues={{
                      strategy,
                      isActive,
                      asset
                  }} >
                <Form.Item label="Код"  {...tailItemLayout}
                          name={['strategy','code']}
                          rules={[{required: true, message: 'Пожалуйста, введите код стратегии.'}]}>
                    <Select
                        placeholder="Выберите стратегию"
                    >
                        {strategies.map(strategy => <Option key={strategy.code} value={strategy.code}>{`${strategy.name}`}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="Счет"  {...tailItemLayout}
                          name={['asset','id']}
                          rules={[{required: true, message: 'Пожалуйста, введите счет.'}]}>
                    <Select
                        placeholder="Выберите счет"
                    >
                        {assets.map(asset => <Option key={asset.id} value={asset.id}>{`${asset.name}`}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item {...formCheckboxLayout}
                          name='isActive'
                          valuePropName='checked'
                >
                    <Checkbox>Активный</Checkbox>
                </Form.Item>

{/*                <Form.Item label="Активно"  {...tailItemLayout}
                           name='isActive'
                           valuePropName="checked"
                >
                    <Switch/>
                </Form.Item>*/}

            </Form>
        </Modal>
    );

}

export default TraderStrategyDialog;
